module.exports = __webpack_public_path__ + "media/images/cellar42-topbanner-d6098b15ad3423d0dfa6a1d9e45232fb.png";